import { Injectable } from '@angular/core';

@Injectable()
export class CommonSessionService {
  putSession(session_key: string, session: any) {
    if (session) {
      window.sessionStorage.setItem(session_key, JSON.stringify(session));
    } else {
      window.sessionStorage.removeItem(session_key);
    }
  }

  getSession(session_key: string): any {
    return JSON.parse(window.sessionStorage.getItem(session_key));
  }

  removeSession(session_key: string) {
    window.sessionStorage.removeItem(session_key);
  }
}
